/* eslint-disable no-console */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ApiService from './services/api.service.js';
import JournalService from './services/journal.service.js';
import i18n from './i18n.js';
import Vuelidate from 'vuelidate';
import { directives } from './directives';
import 'cropperjs/dist/cropper.css';
import VueCropper from 'vue-cropperjs';
import * as Sentry from '@sentry/vue';
import { Vue as VueIntegration } from '@sentry/integrations';
import Config from './config.js';
import '@gamelearn/skeletor/dist/bundle.js';
import './registerServiceWorker';

console.log('Gamelearn Accounts', Config.version);

Vue.component(VueCropper);
Vue.config.productionTip = false;

Vue.use(Vuelidate);

for (let entry in directives) {
  Vue.directive(entry, directives[entry]);
}

if (Config.sentry.show) {
  Sentry.init({
    Vue,
    dsn: Config.sentry.dsn,
    integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true })],
    environment: Config.environment
  });
  window.Sentry = Sentry;
}

new Vue({
  router,
  store,
  async created() {
    JournalService.bootstrap();
    ApiService.interceptors.response.use(
      (res) => res,
      (error) => {
        const notification = {
          type: 'error',
          message: `feedback.errors.${error.response.data.errorCode}`,
          show: true
        };
        this.$store.dispatch('addNotification', notification);
        console.error(error.response);
        // todo try to reconnect
        if (error.response.status === 401) {
          this.$store.dispatch('logout');
        } else {
          return Promise.reject(error);
        }
      }
    );
  },
  i18n,
  render: (h) => h(App)
}).$mount('#app');
